import { useEffect, useRef, useState } from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import dayjs from "dayjs";
import { formatAddress } from "../../../../helpers/helper";
import "./style.css";
export const CustomListItem = ({
  notification,
  isSelectedItem,
  setSelectedItem,
}) => {
  const {
    messageId,
    createdAtUTC,
    facilityAddress,
    facilityName,
    facilityPhoneNumber,
    messageName,
    messagePlume,
    messageTime,
    isProcessed,
  } = notification;
  const date = dayjs(messageTime).format("DD.MM.YYYY");
  const time = dayjs(messageTime).format("HH:mm");
  const borderColor = isSelectedItem
    ? "#0252A7"
    : isProcessed
    ? "transparent"
    : "#FB0004";
  const address = formatAddress(facilityAddress);
  const handleSelectItem = () => {
    setSelectedItem(messageId);
  };

  const textRef = useRef(null);
  const [isOverflowed, setIsOverflowed] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      const isTextOverflowed =
        textRef.current.scrollWidth > textRef.current.clientWidth;
      setIsOverflowed(isTextOverflowed);
    }
  }, [facilityName]);

  return (
    <ListItem
      sx={{
        border: `3px solid ${borderColor}`,
      }}
      className="card"
      component="div"
      onClick={handleSelectItem}
      disablePadding
    >
      <Box className="cardObjectInfo">
        <Tooltip
          title={isOverflowed ? facilityName : ""}
          placement="right"
          arrow
          followCursor
          disableHoverListener={!isOverflowed} // Отключаем тултип, если нет переполнения
        >
          <Typography
            ref={textRef}
            className="cardDateText"
            sx={{
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2, // Ограничиваем число строк
              overflow: "hidden",
              textOverflow: "ellipsis",
              wordBreak: "break-word", // Для корректного переноса слов
            }}
          >
            {facilityName || ""}
          </Typography>
        </Tooltip>
        <Typography className="card-text">{address}</Typography>
        <Typography className="card-text">
          {facilityPhoneNumber || ""}
        </Typography>
      </Box>
      <Typography className="cardDateText">{`${messageName}, ${messagePlume}`}</Typography>
      <Box className="cardDate">
        <Typography className="card-text card-text-bold">{date}</Typography>
        <Typography className="card-text card-text-bold">{time}</Typography>
      </Box>
    </ListItem>
  );
};
